var product_app = new Vue({
    el: '#product-app',
    data: {
        product: product,
        current: current,
        quantity: 1,
        currentOption1: defaultOption1,
        currentOption2: defaultOption2,
    },
    watch: {
        current: function() {
            if (this.current.featured_image) {
                $('#product-image').attr("src", this.current.featured_image.src);
            } else {
                $('#product-image').attr("src", this.product.featured_image);
            }
        },
        currentOption1: function() {
            //Normally, you'd just make 'current' a computed property. Note that for products with 2 options, currently, it's a bound model! (v-model="current" is conditionally rendered.)
            //For now, I'm using a watch on currentOption1 to change it since the page doesn't have a fixed number of options to display.
            //(Some products don't have an option1 or option2, some have option1, some have both. You'll have to test on all three if you use a computed property.)
            var me = this;
            this.current = this.variants.filter(function (variant) { return variant.option1 == me.currentOption1 && (!variant.option2 || variant.option2 == me.currentOption2) })[0];
        }
    },
    computed: {
            youSave: function() {
                var compareAt = this.product.compare_at_price;
                var price = this.product.price;
                return compareAt - price;
            },
            youSavePercent: function() {
                var compareAt = this.product.compare_at_price;
                var price = this.product.price;
                return Math.ceil((price / compareAt) * 100);
            },
            variants: function() {
                variants.forEach((variant) => {
                    variant.handle = variant.title.replace(/\s+/g, '-').toLowerCase();
                });
                return variants;
            },
            microsuedeVariants: function() {
                return this.variants.filter(function(variant) {
                    return (variant.option2 == 'Premium MicroSuede') && variant.available;
                });
            },
            ultraFurVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'UltraFur' && variant.available;
                });
            },
            luxuryFurVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'LuxuryFur' && variant.available;
                });
            },
            pebbleVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'Pebble' && variant.available;
                });
            },
            corduroyVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'Corduroy' && variant.available;
                });
            },
            fauxLinenVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'Faux Linen' && variant.available;
                });
            },
            nylonVariants: function() {
                return this.variants.filter(function(variant) {
                    return variant.option2 == 'Nylon' && variant.available;
                });
            },
            carouselImages: function() {
                return this.product.images.filter((image) => {
                    return image.includes(this.current.sku + "-A") || image.includes(this.current.sku);
                });
            },
            materialGroups: function () { 
                    return [...new Set(variants.map(p => p.option1))];
                }
    },
    methods: {
        increaseQuantity: function() {
            if (this.quantity < 99) {
                this.quantity++;
            }
        },
        decreaseQuantity: function() {
            if (this.quantity > 1) {
                this.quantity--;
            }
        },
        sortedVariantArray: function(query) {
                return this.variants.filter((variant) => {
                    return variant.option1 == query && variant.available;
                })
        }
    },
    filters: {
        money: function(value) {
            let price = value.toString();
            price = price.split('');
            price.splice(price.length - 2, 0, ".");
            price = price.join('');
            return `${price}`;
        }
    },
    delimiters: ['{[{', '}]}']
});